import { useAppSelector } from 'app/hooks';
import LevelComponent from 'components/structure-page/2d/level';
import { getAssignedImageForLevel } from 'utils/structure';
import { getLayoutImageLevels } from 'utils/structure-level-pager';
import LevelImageSection from './level-image-section';

type LayoutImagesListProps = Readonly<{
  onImageDropForCrop?: (attachmentId: number, levelUniqueId: string) => void;
}>;

export default function LayoutImagesList({
  onImageDropForCrop
}: LayoutImagesListProps) {
  const { structure, structureAttachments, structureImageAssignments } =
    useAppSelector((state) => state.structure);

  const levels = getLayoutImageLevels(structure);

  if (levels.length === 0) {
    return (
      <div className='flex h-full w-full items-center justify-center text-center text-gray-500'>
        {structure.length === 0
          ? 'No levels to show yet. Set the number of levels on the Basic Info step.'
          : 'No levels need layout images since no heating or cooling is being added to any level.'}
      </div>
    );
  }

  return (
    <div className='mx-auto flex w-full max-w-3xl flex-col gap-3'>
      {levels.map((level) => {
        const hasImage = Boolean(
          getAssignedImageForLevel(
            level.uniqueId,
            structureImageAssignments,
            structureAttachments
          )
        );
        return (
          <LevelImageSection
            key={level.uniqueId}
            label={level.label}
            indicatorChecked={hasImage}
          >
            <LevelComponent
              level={level}
              imagePreviewMode
              embedded
              onImageDropForCrop={onImageDropForCrop}
            />
          </LevelImageSection>
        );
      })}
    </div>
  );
}
